import { defineMessages } from "react-intl";
const messages = defineMessages({
    actionsEditRequest: {
        id: "app.scanRequests.table.button.editRequest",
        defaultMessage: "Edit Request",
    },
    saveEditRequest: {
        id: "app.scanRequests.table.button.saveChanges",
        defaultMessage: "Save Changes",
    },
    cancelRequest: {
        id: "app.scanRequests.table.button.cancelRequest",
        defaultMessage: "Cancel Request",
    },
    editRequestAccessDetailsLabel: {
        id: "app.scanRequests.table.editRequest.label.accessDetails",
        defaultMessage: "Access Details",
    },
    editRequestAccessDetailsPlaceholder: {
        id: "app.scanRequests.table.editRequest.placeholder.accessDetails",
        defaultMessage: "Select the Access Details",
    },
    editRequestAccessDetailsSpecifyPlaceholder: {
        id: "app.scanRequests.table.editRequest.placeholder.accessDetailsSpecify",
        defaultMessage: "Please Specify",
    },
    editRequestEarliestDateLabel: {
        id: "app.scanRequests.table.editRequest.label.earliestDate",
        defaultMessage: "When is the earliest we can begin?",
    },
    editRequestEarliestDatePlaceholder: {
        id: "app.scanRequests.table.editRequest.placeholder.earliestDate",
        defaultMessage: "mm/dd/yy",
    },
    editRequestAccessSpecialInstructionsLabel: {
        id: "app.scanRequests.table.editRequest.label.specialInstructions",
        defaultMessage: "Special Instructions",
    },
    editRequestAccessSpecialInstructionsPlaceholder: {
        id: "app.scanRequests.table.editRequest.placeholder.specialInstructions",
        defaultMessage: "Please let our team know any extra information.",
    },
    cancellationReasonLabel: {
        id: "app.scanRequests.table.cancelRequest.label.cancellationReason",
        defaultMessage: "Cancellation Reason",
    },
    cancellationReasonPlaceholder: {
        id: "app.scanRequests.table.cancelRequest.placeholder.cancellationReason",
        defaultMessage: "Inform your reason for cancellation",
    },
    editRequestAccessEarliestDateError: {
        id: "app.scanRequests.table.newRequest.earliestDate.error",
        defaultMessage: "Earliest Date is required",
    },
    editRequestAccessEarliestDateFormatError: {
        id: "app.scanRequests.table.editRequest.earliestDateFormat.error",
        defaultMessage: "Date format is invalid. Follow mm/dd/yy",
    },
    editRequestAccessAccessDetailsError: {
        id: "app.scanRequests.table.editRequest.accessDetails.error",
        defaultMessage: "Earliest Date is required",
    },
    editRequestAccessAccessDetailsSpecificationError: {
        id: "app.scanRequests.table.editRequest.accessDetailsSpecification.error",
        defaultMessage: "Specifications about Access Details are required",
    },
    confirmCancelRequest: {
        id: "app.scanRequests.table.button.confirmCancelRequest",
        defaultMessage: "Confirm Cancellation",
    },
    backCancelRequest: {
        id: "app.scanRequests.table.button.backCancelRequest",
        defaultMessage: "Back",
    },
    updateRequestSuccess: {
        id: "app.scanRequests.table.editRequest.success",
        defaultMessage: "Scan Request updated successfully.",
    },
});
export default messages;
